import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { selectOverlayIsVisible } from '../../redux/user/user.selectors';

const LoadingOverlay = ({ overlayIsVisible }) => {

  if (overlayIsVisible) {
    return (
      <div className="station-map-loading-overlay__wrapper" role="alert" aria-live="polite">
        <div className="station-map-loading-overlay__message-container">
          <div className="station-map-loading-overlay__animation"><div></div><div></div></div>
          <p className="station-map-loading-overlay__message">
            Retrieving data&hellip;
          </p>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

LoadingOverlay.propTypes = {
  "overlayIsVisible": PropTypes.bool
};

const mapStateToProps = (state) => {
  return {
    "overlayIsVisible": selectOverlayIsVisible(state)
  }
};

export default connect(mapStateToProps)(LoadingOverlay);